<template>
  <prospect-list
    :api-url="apiUrl"
    :families-api-url="familiesApiUrl"
    :summary-url="summaryUrl"
    :funnel-url="funnelUrl"
    :inquiry-url="inquiryUrl"
    :team-name="teamName"
    :team-timezone="teamTimezone"
    :questions-url="questionsUrl"
    :mention-suggest-url="mentionSuggestUrl"
    :current-author-id="currentAuthorId"
    :current-author-type="currentAuthorType"
    :endpoint="endpoint"
    :access-key="accessKey"
    :auth-token="authToken"
    :cloudfront-base-url="cloudfrontBaseUrl"
    :coach-options="coachOptions"
  />
</template>

<script>
import ProspectList from './prospect_list.vue';

export default {
  name: 'prospect-page',
  components: { ProspectList },
  props: {
    apiUrl: { type: String, required: true },
    familiesApiUrl: { type: String, required: true },
    summaryUrl: { type: String, required: true },
    funnelUrl: { type: String, required: true },
    inquiryUrl: { type: String, required: true },
    teamName: { type: String, default: '' },
    teamTimezone: { type: String, default: '' },
    questionsUrl: { type: String, default: '' },
    mentionSuggestUrl: { type: String, default: '' },
    currentAuthorId: { type: Number, required: true },
    currentAuthorType: { type: String, required: true },
    endpoint: { type: String, default: '' },
    accessKey: { type: String, default: '' },
    authToken: { type: String, default: '' },
    cloudfrontBaseUrl: { type: String, default: '' },
    coachOptions: { type: Array, default: () => [] },
  },
};
</script>
